<template>
  <div>
    <div>
      Lesen Sie hier unsere <a @click="openDSB">Datenschutzbestimmungen</a>.
    </div>
    <v-checkbox
      :label="label"
      v-model="checked"
      :readonly="readonly" />

    <v-dialog
      v-model="dsbDialogActive"
      scrollable>
      <v-card>
        <v-card-title>
        </v-card-title>
        <v-card-text>
          <div
            v-if="dsb"
            v-html="dsb" />
          <div
            v-else
            class="dsb-loader">
            <v-progress-circular
              color="primary"
              indeterminate />
            <div>
              Lade Datenschutzbestimmungen ...
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn
            depressed
            color="primary"
            @click="dsbDialogActive = false">
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import BL from '@/bl/bl'

export default {
  name: 'InputDSB',

  props: {
    value: {
      type: Boolean,
      default: false
    },

    label: {
      type: String,
      default: 'Datenschutzbestimmungen akzeptiert'
    },

    readonly: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      checked: this.value,
      isLoadingDSB: false,
      dsbDialogActive: false
    }
  },

  watch: {
    value (val) {
      this.checked = val
    },

    checked (val) {
      this.$emit('input', val)
    }
  },

  computed: {
    dsb () {
      return BL.getDSB()
    }
  },

  methods: {
    openDSB () {
      this.dsbDialogActive = true
      this.isLoadingDSB = true

      BL.requestDSB()
        .finally(_ => {
          this.isLoadingDSB = false
        })
    }
  }
}
</script>

<style lang="scss">
  .dsb-loader {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 2em;
  }
</style>
